import MenuList2 from './MenuList2';
export default MenuList2;
